// extracted by mini-css-extract-plugin
export var downArrow = "_jb-0";
export var infoTooltipIcon = "_jb-3";
export var label = "_jb-1";
export var optionCard = "_jb-4";
export var upArrow = "_jb-2";